import React, { useEffect, useState } from 'react';
import { Grid, Paper, Dialog, Typography, withStyles } from '@material-ui/core';
import { getDownloadButtons, checkAvailableKeys, checkIfAvailable, alternativeDownloads, styles } from './DownloadPage';
import { snackActions } from '../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../sc-utilities';
import AppLogoLoading from '../sc-logo';
import { connect } from 'react-redux';

const downloadButtons = (translations) => [
    { downloadKey: 'mobile_win', name: translations['mobile_win'] || 'Mobile Windows' },
    { downloadKey: 'mobile_osx', name: translations['mobile_osx'] || 'Mobile macOS' },
    { downloadKey: 'mobile_linux', name: translations['mobile_linux'] || 'Mobile Linux' },
    { downloadKey: 'mobile_linux_app', name: translations['mobile_linux_app'] || 'Mobile Linux application' },
];

export const icon = (
    <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#7485FF"
            d="M30.8838 18.8696L24.9024 22.4L24.4751 9.0087H18.6768V26.0522L15.625 27.8783L12.5733 26.0522V9.0087H6.77491L6.34766 22.4L0.305176 18.8696L0.671387 9.0087L0.854493 2.86087L0.976563 0H7.08009L6.95802 2.86087H12.5733V0H18.6768V2.86087H24.292L24.17 0H30.2735L30.3956 2.86087L30.5787 9.0087L30.8838 18.8696Z"
        />
        <path
            fill="#7485FF"
            d="M31.25 29.278L25.2686 32.8084L15.625 38.4084L5.98145 32.8084L0 29.278L0.244141 22.3389L6.22559 25.8693L10.0098 28.0606L12.5733 29.5823L15.564 31.3476L15.625 31.4084L18.6768 29.5823L25.0244 25.8693L31.0059 22.3389L31.25 29.278Z"
        />
    </svg>
);

const Mobile = (props) => {
    const { classes, translations, permissions, activeCustomerID } = props;
    const [availableKeys, setAvailableKeys] = useState();
    const [privateAvailableKeys, setPrivateAvailableKeys] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchKeys = async () => {
            const res = await checkAvailableKeys(activeCustomerID).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            const privateRes = await checkAvailableKeys(activeCustomerID, false).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            if (res?.status === 200 && privateRes?.status === 200) {
                setAvailableKeys(res.data.result.data);
                setPrivateAvailableKeys(privateRes.data.result.data);
            }
            setLoading(false);
        };
        fetchKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translations]);

    return (
        <Paper className={classes.root}>
            {hasPermission(permissions, 'binary_image_download') && (
                <>
                    <div className={classes.customToolbar}>
                        <div className={classes.tableTitle}>
                            {BackButton(translations, classes.customTooltip)}
                            <Typography className={classes.typography}>
                                {translations['downloads'] || 'Downloads'}
                            </Typography>
                        </div>
                    </div>
                    {!loading && (
                        <>
                            <Grid container direction="row" className={classes.grid}>
                                <Grid item ms={12} lg={6}>
                                    <h2>
                                        {icon} Mobile{' '}
                                        {classes.latestVersionSpan && (
                                            <span className={classes.latestVersionSpan}>
                                                - {translations['latest_version'] || 'Latest Version'}
                                            </span>
                                        )}
                                    </h2>
                                    <p>
                                        {translations['mobile_download_page'] ||
                                            'Complete tool for secure erasure & diagnostics of smartphones and tablets (iOS & Android).'}
                                    </p>
                                </Grid>
                                <Grid item ms={6} lg={6} container direction="row" justify="center" alignItems="center">
                                    {getDownloadButtons(
                                        downloadButtons(translations),
                                        availableKeys,
                                        classes,
                                        privateAvailableKeys
                                    )}
                                    {checkIfAvailable(
                                        availableKeys,
                                        downloadButtons(translations),
                                        alternativeDownloads,
                                        classes,
                                        translations,
                                        privateAvailableKeys
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        open={loading}
                        PaperProps={{
                            classes: {
                                root: classes.loadingScreen,
                            },
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Mobile));
